import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {ConfigurationService} from '~/app/core/services/configuration.service';
import {ErrorService} from '~/app/core/services/error.service';
import {SystemConfig} from '@model/SystemConfig';
import {FileName} from '@model/FileName';
import {StoreConfig} from '@model/StoreConfig';
import {Observable, lastValueFrom} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Package} from '@model/Package';
import {BaseService} from "~/app/core/services/base.service";

const GET_SYSTEM_CONFIG = '/common/systemconfig/'; //{hoId}  (GET)
const UPDATE_SYSTEM_CONFIG = '/common/systemconfig/'; //{hoId}  (PUT)
const UPDATE_STORE_CONFIG = '/common/storeconfig/'; //{hoId}  (PUT)
const GET_STORE_CONFIG = '/common/storeconfig/'; //{user}/{hoId}  (GET)

// const GET_PACKAGE_NAME = '/common/pkg/'; //{hoId}  (GET)
// const GET_PACKAGE_NAMES = '/common/pkgs/'; //{hoId}  (GET)

const GET_PKGS = '/common/pkgs?hoId='; // hoid
const GET_FILES = '/common/files/'; // packageName ? hoId={hoId}
const FILE_DATA = '/common/datafile/'; // {hoId}
// const GET_FILE_NAMES = '/common/files/'; //{pkg}  (GET)
// const GET_SELECTED_FILES = '/common/link/'; //{hoId}/{pkg}/{module}


const ADD_SEGMENT = '/common/segments/';  // POST
const DELETE_SEGMENT = '/common/segments/';  // DELETE
const UPDATE_SEGMENT = '/common/segments/';  // PUT

@Injectable({
  providedIn: 'root'
})
export class StoreConfigService {

  public hoId: string = '';
  public userId: string = '';

  constructor(private baseService: BaseService,
              private configuration: ConfigurationService,
              private errorService: ErrorService) {
  }

  async getSystemConfig(hoId: string) {
    console.warn(this.configuration.RESTURL + GET_SYSTEM_CONFIG + hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getSystemConfig',
      'store-config-service',
      this.configuration.RESTURL + GET_SYSTEM_CONFIG + hoId))
      .catch(this.errorService.handleError('store-config.service getSystemConfig(' + hoId + ')', []));
    return results as SystemConfig;
  }


  updateSystemConfig(systemConfig: SystemConfig): Observable<any> {
    console.warn(this.configuration.RESTURL + UPDATE_SYSTEM_CONFIG + this.hoId + '/' + JSON.stringify(systemConfig));
    return this.baseService.putHttpObject<any>(
      'updateSystemConfig',
      'store-config-service',
      this.configuration.RESTURL + UPDATE_SYSTEM_CONFIG + this.hoId, systemConfig)
      .pipe(
        catchError(this.errorService.handleError('storeConfig.service  updateSystemConfig', []))
      );
  }


  async getStoreConfig(hoId: string, userId: string) {
    this.hoId = hoId;
    console.warn(this.configuration.RESTURL + GET_STORE_CONFIG + userId + '/' + hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getStoreConfig',
      'store-config-service',
      this.configuration.RESTURL + GET_STORE_CONFIG + userId + '/' + hoId))
      .catch(this.errorService.handleError('store-config.service getStoreConfig(' + userId + ', ' + hoId + ')', []));
    return results as StoreConfig[];
  }

  updateStoreConfig(storeConfig: any): Observable<any> {
    console.warn(this.configuration.RESTURL + UPDATE_STORE_CONFIG + this.serializeModels(storeConfig));
    return this.baseService.putHttpObject<any>(
      'updateStoreConfig',
      'store-config-service',
      this.configuration.RESTURL + UPDATE_STORE_CONFIG, this.serializeModels(storeConfig))
      .pipe(
        catchError(this.errorService.handleError('store-config.service  updateStoreConfig', []))
      );
  }


  async getPackageNames() {
    console.warn(this.configuration.RESTURL + GET_PKGS + this.hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getPackageNames',
      'store-config-service',
      this.configuration.RESTURL + GET_PKGS + this.hoId))
      .catch(this.errorService.handleError('store-config.service getPackageNames()', []));
    return results as Package[];
  }


  async getFileNames(pkg: string) {
    console.warn(this.configuration.RESTURL + GET_FILES + pkg + '?hoId=' + this.hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getFileNames',
      'store-config-service',
      this.configuration.RESTURL + GET_FILES + pkg + '?hoId=' + this.hoId))
      .catch(this.errorService.handleError('store-config.service getFileNames(' + pkg + ')', []));
    return results as FileName[];
  }

  // async getSelectedFiles(hoId: string, pkg: string, module: string) {
  //   console.warn(this.configuration.RESTURL + GET_SELECTED_FILES + hoId + '/' + pkg + '/' + module);
  //   const results = await this.http.get(this.configuration.RESTURL + GET_SELECTED_FILES + hoId + '/' + pkg + '/' + module)
  //     .toPromise()
  //     .catch(this.errorService.handleError('store-config.service getSelectedFiles(' + hoId + ', ' + pkg + ', ' + module + ')', []));
  //   return results as FileName[];
  // }

  addSegment(storeConfig: StoreConfig[]): Observable<any> {
    return this.baseService.postHttpObject<any>(
      'addSegment',
      'store-config-service',
      this.configuration.RESTURL + ADD_SEGMENT, storeConfig)
      .pipe(
        catchError(this.errorService.handleError('store-config.service addSegment(itemGLSetup)', []))
      );
  }

  deleteSegment(storeConfig: StoreConfig[]): Observable<any> {
    const test = JSON.stringify(storeConfig);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(storeConfig)

    };
    return this.baseService.deleteHttpObject<any>(
      'deleteSegment',
      'store-config-service',
      this.configuration.RESTURL + DELETE_SEGMENT, options)
      .pipe(
        catchError(this.errorService.handleError('store-config.service deleteSegment(' + storeConfig + ')', []))
      );
  }

  saveFileData(hoId: string, pkgOld: String, moduleOld: String, newPkg: String, newModule: String, fileList: string[]) {
    const data = {
      'pkgOld': pkgOld,
      'moduleOld': moduleOld,
      'pkg': newPkg,
      'module': newModule,
      'fileList': fileList
    }
    return this.baseService.putHttpObjectOptions<any>(
      'saveFileData',
      'store-config-service',
      this.configuration.RESTURL + FILE_DATA + hoId, JSON.stringify(data))
      .pipe(
        catchError(this.errorService.handleError('store-config.service saveFileData()', []))
      );
  }

  private serializeModels(data?: any): string {
    console.error(typeof data);
    console.log(data);
    if (data instanceof Object) {
      return `${JSON.stringify([data])}`;
    } else {
      return data;
    }
  }
}

